'use strict';

module.exports = require('./routeHandler');